import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const postAddDomainSlice = createApi(`PostAddDomainSlice`,"POST");

const PostAddDomainSlice = createSlice({
  name: 'PostAddDomainSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postAddDomainSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postAddDomainSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postAddDomainSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PostAddDomainSlice.reducer;